module.exports = __webpack_public_path__ + "img/kyc2-1.d56f7e15.png";